import { isBlank, isJSONObject } from "./string";

type ObjectType = Record<string, unknown>;

export function parseQueryString<T extends ObjectType>(qs: string): T {
  const res = {};

  if (isBlank(qs)) return res as T;

  const params = new URLSearchParams(qs);

  for (const [key, value] of params.entries()) {
    let parsed;

    if (value === "true" || value === "false") parsed = /true/.test(value);
    else if (!isNaN(Number(value)) && !isBlank(value)) parsed = Number(value);
    else if (isJSONObject(value)) parsed = JSON.parse(value);
    else parsed = value;

    res[key] = parsed;
  }

  return res as T;
}
